import { formatConfigToText } from '../helpers';
import { ConfigOrderDetails } from '../types';

async function copyOrderDetails(orderConfig: ConfigOrderDetails) {
  const formatedText = formatConfigToText(orderConfig);
  await navigator.clipboard.writeText(formatedText);
}

export default copyOrderDetails;
